
import { canSendMailService } from "../../../services/EmailSettingService";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { updateCanSendMailService } from "../../../services/EmailSettingService";

export const fetchCanSendMail = createAsyncThunk(
  "mail/fetchCanSendMail",
  async (_, { rejectWithValue }) => {
      try {
          const response = await canSendMailService();
         return response;
       } catch (error) {
         return rejectWithValue(error.message || "Something went wrong");
       }}
);


// ✅ PUT 
export const updateCanSendMail = createAsyncThunk(
  "mail/updateCanSendMail",
  async (enabled, { rejectWithValue }) => {
    try {
      const response = await updateCanSendMailService(enabled);
      return response;
    } catch (error) {
      return rejectWithValue(error.message || "Something went wrong");
    }
  }
);